import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);
// 登录验证
export default new Vuex.Store({
    state: {
        user: false,
        // url: 'http://121.37.99.223',
        //测试服
        // api: 'http://hailiang.58vip.cn/CM-API/api',
        // uploadApi:'http://hailiang.58vip.cn/CM-API/api/uploadImgOss',
        // url:'http://hailiang.58vip.cn/#/'

        //正式服
        api: 'https://education.vastdata.com.cn/CM-API/api',
        uploadApi:'https://education.vastdata.com.cn/CM-API/api/uploadImgOss',
        url:'https://education.vastdata.com.cn/pc/#/'
    },
    mutations: {
       
    },
    getters: {
        url: state => state.url,
        api: state => state.api,
        uploadApi: state => state.uploadApi,
    }
})


// WEBPACK FOOTER //
// ./src/vuex/store.js